import { NAV_ITEM_BOOKMARKS_GROUP_ID } from '../../constants/Bookmarks';
import { NAV_BOOKMARKED_ITEMS_ATTR } from '../../constants/navPersona';
import { defaultValues } from '../../data/DefaultTranslationValues';
import { captureException } from '../../utils/sentryAPI';
export function getBookmarksFromPortalUserAttributes({
  portalUserAttributes
}) {
  try {
    if (portalUserAttributes[NAV_BOOKMARKED_ITEMS_ATTR]) {
      return JSON.parse(portalUserAttributes[NAV_BOOKMARKED_ITEMS_ATTR]);
    }
  } catch (e) {
    if (e instanceof Error) {
      captureException(e);
    }
  }
  return undefined;
}
const primaryItemTranslationKey = 'nav.bookmarks2.primaryNav';
export const getStoreWithBookmarks = store => {
  // the developer nav doesn't support bookmarks
  if (store.portal.portalType === 'DEV') {
    return store;
  }
  const {
    portalUserAttributes
  } = store;
  const bookmarks = getBookmarksFromPortalUserAttributes({
    portalUserAttributes
  });
  store.navItems.byId[NAV_ITEM_BOOKMARKS_GROUP_ID] = {
    id: NAV_ITEM_BOOKMARKS_GROUP_ID,
    children: [],
    ancestors: [],
    label: store.translations[primaryItemTranslationKey] || defaultValues[primaryItemTranslationKey]
  };
  store.navItems.primaryNav.navItems = [{
    id: NAV_ITEM_BOOKMARKS_GROUP_ID,
    children: []
  }, ...store.navItems.primaryNav.navItems];
  if (bookmarks) {
    store.navItems.byId[NAV_ITEM_BOOKMARKS_GROUP_ID].children = bookmarks.ids.reduce((acc, id) => {
      const navItem = store.navItems.byId[id];
      if (navItem) {
        acc.push({
          id,
          children: []
        });
        store.navItems.byId[id] = Object.assign({}, navItem, {
          isBookmarked: true
        });
      }
      return acc;
    }, []);
  }
  return store;
};